import React, { useEffect } from 'react';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { IsEnglish } from '../../utils/language';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLink, faAnglesLeft, faAnglesRight } from "@fortawesome/free-solid-svg-icons"
import IconButton from '@material-ui/core/IconButton';
import * as keyMenu from '../../scripts/KeyMenu';
import * as leaveStatus from '../../scripts/LeaveRequestStatusCode';
import Carousel from 'react-material-ui-carousel'
import background_absence from "../../images/background_absence.png";

const useStyles = makeStyles((theme) => ({
    divContent: {
        border: '0px solid var(--color3)',
        margin: '5px'
    },
    liContent: {
        background: 'linear-gradient(#2ba522ba, #2d6728ba)',
        borderRadius: '10px',
        margin: '15px 15px',
        padding: '8px',
        textAlign: 'left',
        boxShadow: '1px 1px 7px 0px #7f7f7f',
        minHeight: '100px',
        fontWeight: 'bold',
        minHeight: '100px',
        '& > svg': {
            float: 'left',
            margin: '4px 10px !important'
        },
        '& > span': {
            display: 'table'
        }
    },
    divFooter: {
        color: '#333333',
        textAlignLast: 'center',
        '& > svg': {
            margin: '0px 10px 0px 0px'
        }
    },
    linkGoIcon: {
        fontSize: '16px !important',
        padding: 'unset'
    },
    approved: {
        color: '#ffffff'
    },
    cancelled: {
        color: '#ffffff'
    },
    cancelled_request: {
        color: '#ffffff'
    },
    opened: {
        fontWeight: 'bold',
        color: '#ffffff'
    },
    divResetCarouselLeft: {
        display: 'table',
        top: '-15px',
        left: '10px',
        position: 'relative',
        float: 'left'
    },
    divResetCarouselRight: {
        display: 'table',
        top: '-15px',
        position: 'relative',
        float: 'right'
    },
    backContent: {
        borderRadius: '8px',
        padding: '10px',
        minHeight: '95px',
        color: 'var(--color2)'
    },
    backContentDesktop: {
        background: 'rgb(0 0 0 / 40%)',
        borderRadius: '8px',
        padding: '10px',
        marginLeft: '20px',
        marginRight: '20px'
    },
    spanNoContent: {
        color: 'var(--color2)',
        textAlign: 'center',
        display: 'table',
        width: '100%',
        marginTop: '21px'
    },
    divRootAbsence: {
        color: '#ffffff',
        display: 'inline-block',
        float: 'left',
        width: '100%',
        '& > svg': {
            float: 'left',
            margin: '4px 10px !important'
        },
    },
    absenceImg: {
        width: '35px',
    },
    absenceTitle: {
        verticalAlign: 'middle',
        marginLeft: '10px',
        fontVariant: 'all-petite-caps',
        fontSize: '18px'
    }
}));

function Absence(props) {
    const classes = useStyles();

    const [index, setIndex] = React.useState(0);
    const [data, setData] = React.useState(null);
    const [isMobile, setIsMobile] = React.useState(false);

    useEffect(() => {
        const screenWidth = document.body.clientWidth;

        setIsMobile(screenWidth < 800)
    }, []);

    useEffect(() => {
        if (props.data !== null && props.data !== undefined && props.data.length > 0) {
            loadAbsence();
        } else {
            document.querySelector('#divResetCarouselLeft').style.visibility = 'hidden';
            document.querySelector('#divResetCarouselRight').style.visibility = 'hidden';
        }
    }, [props.data]);

    const loadAbsence = () => {
        setData(props.data);
    }

    const handleSelectedPage = () => {
        props.handleSelectedPage(keyMenu.MENU_REQUEST);
    }

    const getClass = (status) => {
        switch (status) {
            case leaveStatus.Status_Canceled:
                return classes.cancelled;
            case leaveStatus.Status_Cancel_Request:
                return classes.cancelled_request;
            case leaveStatus.Status_Close:
                return classes.approved;
            case leaveStatus.Status_Opened:
                return classes.opened;
            break
                return '';
        }
    }

    const onChange = (index, item) => {
        if (index == data.length - 1) {
            document.querySelector('#divResetCarouselLeft').style.visibility = 'visible';
            document.querySelector('#divResetCarouselRight').style.visibility = 'hidden';
        } else if (index == 0) {
            document.querySelector('#divResetCarouselLeft').style.visibility = 'hidden';
            document.querySelector('#divResetCarouselRight').style.visibility = 'visible';
        } else {
            document.querySelector('#divResetCarouselLeft').style.visibility = 'visible';
            document.querySelector('#divResetCarouselRight').style.visibility = 'visible';
        }

        setIndex(index);
    }

    const handleNextIndex = (e) => {
        // This is just to avoid a crash on the Carousel component if you do double click quicly
        document.querySelector('#btnNext').disabled = true;

        setTimeout(() => {
            setIndex((idx) => {
                if (idx == props.data.length - 1) {
                    return 0;
                } else {
                    return idx + 1;
                }
            });
            document.querySelector('#btnNext').disabled = false;
        }, 250)
    }

    const handlePreviousIndex = () => {
        // This is just to avoid a crash on the Carousel component if you do double click quicly
        document.querySelector('#btnPrevious').disabled = true;

        setTimeout(() => {
            setIndex((idx) => {
                if (idx == 0) {
                    return props.data.length;
                } else {
                    return idx - 1;
                }
            });
            document.querySelector('#btnPrevious').disabled = false;
        }, 250)

    }

    return (
        <>
            <div>
                <Carousel
                    autoPlay={false}
                    interval={5000}
                    animation={'slide'}
                    duration={100}
                    //navButtonsAlwaysVisible={!isMobile}
                    //navButtonsAlwaysInvisible={isMobile}
                    navButtonsAlwaysVisible={false}
                    navButtonsAlwaysInvisible={true}
                    swipe={true}
                    indicators={false}
                    onChange={onChange}
                    index={index}
                    navButtonsWrapperProps={{
                        style: {
                            bottom: '0',
                            top: 'unset'
                        }
                    }}
                    navButtonsProps={{
                        style: {
                            height: '40px',
                            width: '40px'
                        }
                    }}
                >
                    {data && data.map((obj, index) =>
                        <div className={`${classes.liContent} ${getClass(obj.status)}`} key={index}>
                            <div className={classes.divRootAbsence}>
                                <img className={classes.absenceImg} src={background_absence} />
                                <span className={classes.absenceTitle}>{ IsEnglish() ? obj.statusDescE : obj.statusDescF}</span>
                            </div>
                            <div className={classes.backContent}>
                                <span>{IsEnglish() ? obj.descriptionE : obj.descriptionF}</span>
                            </div>
                        </div>                        
                    )}
                </Carousel>
                {(data === null) &&
                    <div className={classes.liContent}>
                        <div className={classes.divRootAbsence}>
                            <img className={classes.absenceImg} src={background_absence} />
                        </div>
                        <div className={classes.backContent}>
                            <span className={classes.spanNoContent}>{i18next.t("home:homeContent.noAbsence")}</span>
                        </div>
                    </div>
                }

                <div id="divResetCarouselLeft" className={classes.divResetCarouselLeft}>
                    <IconButton id="btnPrevious" edge="start" color="inherit" onClick={handlePreviousIndex} aria-label="close">
                        <FontAwesomeIcon icon={faAnglesLeft} className="fa-w-16" />
                    </IconButton>
                </div>
                <div id="divResetCarouselRight" className={classes.divResetCarouselRight}>
                    <IconButton id="btnNext" edge="start" color="inherit" onClick={handleNextIndex} aria-label="close">
                        <FontAwesomeIcon icon={faAnglesRight} className="fa-w-16" />
                    </IconButton>
                </div>
            </div>
            <div className={classes.divFooter}>
                <IconButton className={classes.linkGoIcon} edge="start" color="inherit" onClick={handleSelectedPage} aria-label="close">
                    <FontAwesomeIcon icon={faLink} className="fa-w-16" />
                    <span className={classes.linkGo}>{i18next.t('home:homeContent.goLink')}</span>
                </IconButton>
            </div>
        </>
    );
}
export default withNamespaces(['home'], { wait: true })(Absence);